import { z } from 'zod';
import { logger } from '../utils/logger';

export class ValidationError extends Error {
  constructor(
    message: string,
    public errors: z.ZodError
  ) {
    super(message);
    this.name = 'ValidationError';
  }
}

export { ValidationError as ValidationErrorClass };

export function validateResponse<T>(
  data: unknown,
  schema: z.ZodSchema<T>,
  context?: string
): T {
  try {
    return schema.parse(data);
  } catch (error) {
    if (error instanceof z.ZodError) {
      const contextMsg = context ? ` [${context}]` : '';
      logger.error(`Response validation failed${contextMsg}:`, error.errors);
      throw new ValidationError(
        `Invalid response format${contextMsg}: ${error.errors.map((e) => e.message).join(', ')}`,
        error
      );
    }
    throw error;
  }
}

export function safeValidateResponse<T>(
  data: unknown,
  schema: z.ZodSchema<T>,
  context?: string
): { success: true; data: T } | { success: false; error: ValidationError } {
  try {
    const validated = schema.parse(data);
    return { success: true, data: validated };
  } catch (error) {
    if (error instanceof z.ZodError) {
      const contextMsg = context ? ` [${context}]` : '';
      const validationError = new ValidationError(
        `Invalid response format${contextMsg}: ${error.errors.map((e) => e.message).join(', ')}`,
        error
      );
      return { success: false, error: validationError };
    }
    throw error;
  }
}

